import axios from 'axios';

export const axiosInstance = axios.create({
  baseURL: `${location.protocol}//api.postmon.com.br/v1`
});

export default {
  baseURL: axiosInstance.defaults.baseURL,
  fetch: cep => axiosInstance.get(`/cep/${cep}`)
};
